import React, { useState, useEffect } from 'react';
import { t } from './i18n';

// Notificare despre stocarea din browser, nu cerere de acord (15 septembrie 2026).
//
// Pana acum aici era un banner cu „Accept” si „Refuz”, afisat doar pentru super_admin, iar
// „Refuz” nu refuza nimic. Nici nu avea ce: aplicatia nu pune niciun cookie si nu are nicio
// unealta de analiza sau publicitate. In browser pastreaza doar sesiunea de autentificare
// (Supabase), limba aleasa si faptul ca notificarea asta a fost vazuta. Pentru stocare strict
// necesara nu se cere consimtamant, iar un buton „Refuz” ar sugera ca exista ceva de refuzat.
//
// Se afiseaza o singura data, pentru oricine deschide site-ul (montata in index.js, pe toate
// paginile). Cheia e noua, ca s-o vada si cine raspunsese la bannerul vechi.
const CHEIE = 'nm_notificare_stocare';

export default function CookieBanner() {
  const [vizibil, setVizibil] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(CHEIE)) setVizibil(true);
    } catch (e) { /* browser fara localStorage: nu insistam */ }
  }, []);

  function amInteles() {
    try {
      localStorage.setItem(CHEIE, new Date().toISOString());
      // Raspunsul la bannerul vechi nu mai inseamna nimic.
      localStorage.removeItem('nm_cookies_accept');
    } catch (e) {}
    setVizibil(false);
  }

  if (!vizibil) return null;

  return (
    <div role="region" aria-label={t('bannerCookies', 'eticheta')} style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 9999,
      background: 'white', borderTop: '1.5px solid #D1E8DA',
      boxShadow: '0 -4px 24px rgba(26,107,60,0.08)',
      padding: '16px 24px', display: 'flex', alignItems: 'center',
      justifyContent: 'space-between', gap: 16, flexWrap: 'wrap',
      fontFamily: "'DM Sans', sans-serif",
    }}>
      <div style={{ fontSize: 13, color: '#374151', lineHeight: 1.6, flex: 1, minWidth: 260 }}>
        {t('bannerCookies', 'text')}{' '}
        <a href="/cookies" style={{ color: '#1A6B3C', fontWeight: 600, textDecoration: 'underline' }}>
          {t('bannerCookies', 'aflaMai')}
        </a>
      </div>
      <button onClick={amInteles} style={{
        padding: '8px 18px', borderRadius: 8, border: 'none', flexShrink: 0,
        background: '#1A6B3C', color: 'white', fontFamily: "'DM Sans', sans-serif",
        fontSize: 13, cursor: 'pointer', fontWeight: 600,
      }}>
        {t('bannerCookies', 'amInteles')}
      </button>
    </div>
  );
}
